import { Orientation } from "@westpierstudio/luma/layout";
import { View } from "@westpierstudio/luma/mvc";
import { GameServices } from "game/GameServices";
import { Sprite } from "pixi.js";


export type lineCount = number;

const supportsLineCounts = [5, 30] as const;
export class WinlineCount extends View {

    private display: Record<lineCount, {
        landscape: Sprite;
        portrait: Sprite;
    }> = {};

    winLineCount = 30;
    orientation: Orientation = `landscape`;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {factory, resources} = this.services;
        const spec = resources.getSpec(`winlinecount`);

        for (const winLineCount of supportsLineCounts) {
            this.display[winLineCount] = {
                landscape: factory.createSprite(spec[`winlineCountLandscape${winLineCount}`], this),
                portrait: factory.createSprite(spec[`winlineCountPortrait${winLineCount}`], this)
            };
        }

        this.hideAll();
    }

    hideAll() {
        for (const winLineCount of supportsLineCounts) {
            this.display[winLineCount].landscape.visible = false;
            this.display[winLineCount].portrait.visible = false;
        }
    }

    setOrientationVisibility() {
        this.display[this.winLineCount].landscape.visible = this.orientation === `landscape`;
        this.display[this.winLineCount].portrait.visible = this.orientation === `portrait`;
    }

    resize(orientation: Orientation): void {
        this.orientation = orientation;
        this.hideAll();
        this.setOrientationVisibility();
    }

    setWinLineCount(lines: number) {
        this.winLineCount = lines;
        this.hideAll();
        this.setOrientationVisibility();
    }
}